import {del} from '../utils'
import {root} from './utils'

export default host => id => del(`${host}${root}/${id}`)
